export default {
  SET_ROUTES: 'SET_ROUTES',
  GEN_ROUTES: 'GET_ROUTES'
}
